import { render, staticRenderFns } from "./facets-group.vue?vue&type=template&id=49f87db4&"
import script from "./facets-group.vue?vue&type=script&lang=ts&"
export * from "./facets-group.vue?vue&type=script&lang=ts&"
import style0 from "./facets-group.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports